import { CodeNameModel } from 'components/common/types';

export const formatTagsToCategory = (
  tags: CodeNameModel[],
  availableTags: Record<string, CodeNameModel[]>,
): CodeNameModel[] => {
  if (!tags.length || tags.every((tag) => tag.category && tag.category !== 'Tag')) {
    return tags;
  }

  return tags.map((tag) => {
    if (tag.category && tag.category !== 'Tag') {
      return tag;
    }

    const matchedCategory = Object.entries(availableTags).find(([, categoryTags]) =>
      categoryTags.some((t) => tag.code === t.code),
    );

    return matchedCategory ? { ...tag, category: matchedCategory[0] } : tag;
  });
};
